var map = {
	"./Community-White.png": 7361,
	"./DataDisclosure-White.png": 632,
	"./Environment-White.png": 7362,
	"./Governance-White.png": 7363,
	"./Marketplace-White.png": 7364,
	"./Purpose-White.png": 7365,
	"./StructureDirectors-White.png": 631,
	"./Workplace-White.png": 7366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;